import { useWindowScroll } from '@vueuse/core';

export default defineNuxtPlugin(() => {
  const { y } = useWindowScroll();
  const config = useRuntimeConfig();
  const brandCode = useBrandCode();

  onNuxtReady(() => {
    pushToDataLayer({
      event: 'environment',
      application_version: config.public.VERSION,
      brand: brandCode.value,
      dev_team: 'TAPP',
      gtm_container: config.public.GTM || 'GTM-W9WWJW',
    });

    const activeSeconds = ref(0);

    // set active seconds on the page with a setInterval
    const interval = setInterval(() => {
      activeSeconds.value++;
    }, 1000);

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      const link = target.closest('a') as HTMLAnchorElement | null;

      if (!link) return;

      const isExternal = link.host && link.host !== window.location.host;

      if (!isExternal) return;

      pushToDataLayer({
        event: 'outbound_click',
        link_text: link.textContent,
        element_id: link.id,
        element_class: link.className,
        url: link.href,
      });
    });

    window.addEventListener('beforeunload', () => {
      clearInterval(interval);

      pushToDataLayer({
        event: 'webpage_summary',
        max_y_offset: y.value,
        active_seconds: activeSeconds.value,
      });
    });
  });
});
